<a class="menu-item-child__link"
   [attr.href]="href"
   [attr.target]="externalHrefTarget"
   [attr.aria-current]="active && href ? 'page' : null">
  <ng-content></ng-content>
</a>
